// src/components/common/LoadingScreen.tsx
import React from 'react';

interface LoadingScreenProps {
  fullScreen?: boolean;
  message?: string;
  variant?: 'primary' | 'secondary' | 'neutral';
}

/**
 * Loading spinner component that can be used as a fullscreen overlay or inline
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  fullScreen = true,
  message = 'Loading...',
  variant = 'primary'
}) => {
  // Map variant to color classes
  const variantClasses = {
    primary: 'text-accent-cool',
    secondary: 'text-secondary',
    neutral: 'text-neutral-mid'
  };

  const containerClasses = fullScreen 
    ? 'min-h-screen flex items-center justify-center gradient-bg' 
    : 'flex items-center justify-center p-4';

  return (
    <div className={containerClasses} aria-live="polite">
      <div className="text-center">
        <div className={`spinner-border ${variantClasses[variant]}`} role="status">
          <span className="visually-hidden">Loading</span>
        </div>
        {message && (
          <p className="mt-2 text-neutral-dark">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;